import { useEffect, useMemo, useState } from "react";
import ArrowLeftLineIcon from "remixicon-react/ArrowLeftLineIcon";
import { useForm} from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import CheckLineIcon from "remixicon-react/CheckLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import CardLayout from "../../../components/utils/CardLayout";
import Button from "../../../components/utils/Button";
import Table from "../../../components/utils/Table";
import {
  twoDigitDecimal,
} from "../../../helpers/commonFunction";
import ChatractivationActions from "../../../redux/chatrActivation/actions";
import "../ActivationRequest.css";
import Alert from "../../../components/utils/Alert";
import planAction from "../../../redux/plan/actions";

const { addChatrBulkActivation, resetChatrValidateMessage } =
  ChatractivationActions;
const BASE_URL = process.env.REACT_APP_SITE_BASE_URL;

const { getPlan } = planAction;

const ChatrBulkActivation = ({ back, searchData }) => {
  const dispatch = useDispatch();
  const { networkResult } = useSelector((state) => state.network);
  const { planResult } = useSelector((state) => state.plan);
  const { tokenData } = useSelector((state) => state.auth);
  const {
    addChatrBulkActivationMessage,
    addChatrBulkActivationError,
    addChatrBulkActivationLoading,
  } = useSelector((state) => state.chatrActivation);
  const [csvError, setCsvError] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [previewSuccessData, setPreviewSuccessData] = useState([]);
  const [previewFailedData, setPreviewFailedData] = useState([]);
  const [showPreviewType, setShowPreviewType] = useState(2);
  const [activationRequests, setActivationRequests] = useState([]);
  const [previewSuccessCount, setPreviewSuccessCount] = useState(0);
  const [csvLimitError, setCsvLimitError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [networkId, setNetworkId] = useState(0);
  const [simType, setSimType] = useState(0);
  const [accountBalance, setAccountBalance] = useState(0);

  const ACTIVATION_LIMIT = 100;

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => {
        setAccountBalance(data.AccountBalance);
      });
  }, [tokenData]);

  useEffect(() => {
    if (csvLimitError !== null && csvLimitError !== undefined) {
      displayAlert(csvLimitError, "alert-danger");
    }
    if (
      addChatrBulkActivationError !== null &&
      addChatrBulkActivationError !== undefined
    ) {
      displayAlert(addChatrBulkActivationError, "alert-danger");
    }
  }, [csvLimitError, addChatrBulkActivationError]);

  useEffect(() => {
    if (addChatrBulkActivationMessage) {
      back();
      dispatch(resetChatrValidateMessage());
    }
  }, [addChatrBulkActivationMessage]);

  useEffect(() => {
    if (previewData.length > 0) {
      let successPreview = previewData.filter((item) => item.Status == 1);
      let failedPreview = previewData.filter((item) => item.Status == 0);
      setPreviewSuccessData(successPreview);
      setPreviewFailedData(failedPreview);
    }
  }, [previewData]);

  useEffect(() => {
    let selectedNetwork =
      networkResult &&
      networkResult.filter((network) => network.ID == networkId);
    dispatch(getPlan(networkId));
  }, [networkId]);

  useEffect(() => {
    if (planResult.length > 0 && networkResult.length > 0) {
      setSelectedPlan(planResult);
    } else {
      setSelectedPlan([]);
    }
  }, [planResult]);

  const filteredNetworkResult = useMemo(() => {
    return networkResult?.filter((network) => network.ID == 1) || [];
  }, [networkResult]);

  useEffect(() => {
    if (filteredNetworkResult.length > 0) {
      setNetworkId(1);
      bulkActivationSetValue("networkID", 1);
      dispatch(getPlan(1));
    }
  }, [filteredNetworkResult]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };

  const {
    register: bulkActivationRegister,
    handleSubmit: bulkActivationHandleSubmit,
    formState: { errors: bulkActivationError },
    watch: bulkActivationWatch,
    reset: bulkActivationReset,
    setValue: bulkActivationSetValue,
    setError: bulkActivationSetError,
    clearErrors: bulkActivationClearErrors,
    control: bulkActivationcontrol,
  } = useForm({
    defaultValues: {
      networkID: "",
      planID: "",
    },
  });

  const planIDWached = bulkActivationWatch("planID");

  const previewColumns = [
    { displayName: "SERIAL NUMBER", key: "SerialNumber" },
    { displayName: "REASON", key: "Reason" },
    { displayName: "VALID", key: "Valid" },
  ];

  const handleNetwork = (e) => {
    e.preventDefault();
    bulkActivationReset({
      planID: "",
      uploadedFile: "",
    });
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessData([]);
    setPreviewFailedData([]);
    dispatch(getPlan(e.target.value));
    setNetworkId(e.target.value);
  };

  const handleSelectPlan = (e) => {
    const planId = e.target.value;
    if (planId) {
      bulkActivationSetValue("planID", planId);
    }
    bulkActivationSetValue("uploadedFile", "");
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessData([]);
    setPreviewFailedData([]);
    setPreviewSuccessCount(0);
    bulkActivationClearErrors(["uploadedFile"]);
  };

  const handlePreviewTableData = (id) => {
    setShowPreviewType(id);
  };

  const handleAddBulkActivation = (data) => {
    data.totalRequests = activationRequests.length;
    const approvedRows = activationRequests.filter((item) => item.status === 1);
    const failedRows = activationRequests.filter((item) => item.status === 0);
    data.successRequests = approvedRows.length;
    data.failedRequestData = failedRows;
    data.failedRequest = failedRows.length;
    data.activationRequests = approvedRows;
    const selectedPlanData = planResult.find(
      (item) => Number(item.PlanID) === Number(data.planID),
    );
    const price = Number(selectedPlanData?.PlanPrice) || 0;
    const purchaseAmount = price * approvedRows.length;
    data.purchaseAmount = purchaseAmount;
    delete data.uploadedFile;
    if (approvedRows.length <= 0) {
      alert("Please upload valid data");
      return;
    }
    if (Number(accountBalance) >= Number(data.purchaseAmount)) {
      console.log("Final Data:", data);
      dispatch(addChatrBulkActivation(data, searchData));
    } else {
      alert("insufficient fund");
    }
  };

  const estimatedAmountColumn = [
    { displayName: "Total Activation", key: "tActivation" },
    { displayName: "Per Activation (Plan)", key: "pActivation" },
    { displayName: "Total Paid", key: "tPaid" },
  ];

  const estimatedAmountDataSource = useMemo(() => {
    if (!planIDWached) {
      return [
        {
          tActivation: 0,
          pActivation: "$0.00",
          tPaid: "$0.00",
        },
      ];
    }

    const selectedPlan = planResult.find(
      (item) => Number(item.PlanID) === Number(planIDWached),
    );

    if (!selectedPlan) {
      return [
        {
          tActivation: previewSuccessData.length,
          pActivation: "$0.00",
          tPaid: "$0.00",
        },
      ];
    }

    const price = Number(selectedPlan.PlanPrice) || 0;
    const totalActivation = previewSuccessData.length;
    const paidTotal = price * totalActivation;

    return [
      {
        tActivation: totalActivation,
        pActivation: `$${twoDigitDecimal(price)}`,
        tPaid: `$${twoDigitDecimal(paidTotal)}`,
      },
    ];
  }, [planIDWached, previewSuccessData.length, planResult]);

  const handleTextareaChange = (val) => {
    bulkActivationClearErrors(["uploadedFile"]);
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessCount(0);
    setActivationRequests([]);
    const dataArr =
      val !== "" ? val.split("\n").map((item) => item.replace(/\s/g, "")) : [];

    if (dataArr.length > 100) {
      bulkActivationSetError("uploadedFile", {
        type: "custom",
        message: "Maximum 100 SIM numbers are allowed",
      });
      return false;
    }

    if (new Set(dataArr).size !== dataArr.length) {
      bulkActivationSetError("uploadedFile", {
        type: "custom",
        message: "Data contain duplicate SIM number",
      });
      return false;
    }

    const dataSource = dataArr.map((item) => {
      const serialNumber = item;
      let error = false;
      let reason = "";
      if (!/^\d+$/.test(serialNumber) || serialNumber.length < 18) {
        reason = "Invalid Serial Number";
        setCsvError(true);
        error = true;
      }

      if (!error) {
        setPreviewSuccessCount((pre) => pre + 1);
      }

      return {
        SerialNumber: serialNumber,
        Reason: reason,
        Valid: error ? (
          <CloseLineIcon color="#e74c3c" />
        ) : (
          <CheckLineIcon color="#2ecc71" />
        ),
        Status: error ? 0 : 1,
      };
    });
    setPreviewData(dataSource);
    let requestData = dataArr.map((item) => {
      const serialNumber = item;
      let error = false;
      let reason = "";
      if (!/^\d+$/.test(serialNumber) || serialNumber.length < 18) {
        reason = "Invalid Serial Number";
        setCsvError(true);
        error = true;
      }
      return {
        simNumber: serialNumber,
        status: error ? 0 : 1,
        reason,
      };
    });
    setActivationRequests(requestData);
  };

  return (
    <CardLayout title="Add Chatr Activation">
      <div className="row mb-3">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            onClick={() => back()}
            className={`btn btn-danger font-weight-bold`}
          >
            <ArrowLeftLineIcon size={16} />
            Back
          </button>
        </div>
      </div>

      <div className="container">
        <form onSubmit={bulkActivationHandleSubmit(handleAddBulkActivation)}>
          {/* FORM FIELDS STARTS FROM HERE */}
          <div className="form-row">
            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Network <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Network"
                name="networkID"
                {...bulkActivationRegister("networkID", {
                  required: "Network is Required",
                })}
                onChange={(e) => {
                  handleNetwork(e);
                }}
              >
                <option value="" key="0" disabled>
                  Select
                </option>
                {filteredNetworkResult.length > 0 &&
                  filteredNetworkResult.map((network) => (
                    <option name="network" value={network.ID} key={network.ID}>
                      {network.NetworkName}
                    </option>
                  ))}
              </select>
              {bulkActivationError && bulkActivationError.networkID && (
                <div className="invalid-feedback">
                  {bulkActivationError.networkID.message}
                </div>
              )}
            </div>

            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Plan <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Plan"
                name="planID"
                {...bulkActivationRegister("planID", {
                  required: "Plan is Required",
                })}
                onChange={(e) => handleSelectPlan(e)}
              >
                <option value="" disabled key="0">
                  Select
                </option>
                {selectedPlan &&
                  selectedPlan.length > 0 &&
                  selectedPlan.map((plan) => (
                    <option name="plan" value={plan.PlanID} key={plan.PlanID}>
                      {" "}
                      {plan.PlanName}{" "}
                    </option>
                  ))}
              </select>
              {bulkActivationError && bulkActivationError.planID && (
                <div className="invalid-feedback">
                  {bulkActivationError.planID.message}
                </div>
              )}
            </div>

            {networkId && planIDWached && (
              <div className="col-md-6 mb-3">
                <label className="ml-2">
                  {" "}
                  Serial Number <span className="text-danger">*</span>{" "}
                </label>
                <textarea
                  className="form-control"
                  rows="6"
                  placeholder="Enter Serial Number"
                  {...bulkActivationRegister("uploadedFile")}
                  onChange={(e) => handleTextareaChange(e.target.value)}
                />

                <small className="text-muted">
                  Enter one Serial Number per line. Maximum {ACTIVATION_LIMIT}{" "}
                  Serial Numbers allowed.
                </small>

                {bulkActivationError?.uploadedFile && (
                  <div className="text-danger mt-1">
                    {" "}
                    {bulkActivationError.uploadedFile.message}{" "}
                  </div>
                )}
              </div>
            )}
          </div>
          {/* FORM FIELDS END HERE */}

          {previewData.length > 0 && (
            <>
              <hr />
              <div className="row p-0 m-0" style={{ cursor: "pointer" }}>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center py-3 preview-box"
                  onClick={() => {
                    handlePreviewTableData(2);
                  }}
                >
                  <h4>Total Submitted : {previewData.length}</h4>
                </div>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                  onClick={() => {
                    handlePreviewTableData(1);
                  }}
                >
                  <h4 className="text-success">
                    Valid : {previewSuccessCount}
                  </h4>
                </div>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                  onClick={() => {
                    handlePreviewTableData(0);
                  }}
                >
                  <h4 className="text-danger">
                    Invalid : {previewData.length - previewSuccessCount}
                  </h4>
                </div>
              </div>
              <div className="col-md-12 mb-3 p-0">
                <Table
                  columns={previewColumns}
                  data={
                    showPreviewType == 1
                      ? previewSuccessData
                      : showPreviewType == 0
                        ? previewFailedData
                        : previewData
                  }
                  pagination={false}
                />
              </div>

              <div className="col-md-12 mb-3 p-0">
                <h4>Price details</h4>
                <Table
                  columns={estimatedAmountColumn}
                  loading={false}
                  data={estimatedAmountDataSource}
                  pagination={false}
                />
              </div>
            </>
          )}
          <hr />

          {showAlert && (
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          )}

          <div className="text-right row">
            <div className="col-md-12">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => back()}
              >
                Close
              </button>
              {activationRequests.filter((item) => item.status === 1).length >
              0 ? (
                <Button
                  title="Submit"
                  style="minWidth:80px"
                  loading={addChatrBulkActivationLoading}
                  buttonClass="btn btn-primary"
                  buttonType="submit"
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </form>
      </div>
    </CardLayout>
  );
};

export default ChatrBulkActivation;
